import { render, staticRenderFns } from "./CurriculumReadNECMonthly.vue?vue&type=template&id=a986530c&scoped=true&"
import script from "./CurriculumReadNECMonthly.vue?vue&type=script&lang=ts&"
export * from "./CurriculumReadNECMonthly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a986530c",
  null
  
)

export default component.exports